import { CommonResponse, SERVICE_BASE, netClient } from '@/apis/api'
import type { IsMemberDTO, MemorialPrivilegeDTO } from '../life/life'
import type { UserMinDTO } from '../user/users'
import type { ThemeDTO } from '../memorize/memorize'
import type { LifeDTO } from '../life/life'

export function getServiceDetail(serviceId: string) {
  return netClient.request<CommonResponse<MemorialServiceDetailsResponse>>(SERVICE_BASE + '/' + serviceId, 'get', {})
}

export interface MemorialServiceDetailsResponse {
  serviceDetails: MemorialServiceDetailDTO
  selectedTheme: ThemeDTO
  isCreatorMember: boolean
}

export interface MemorialServiceDetailDTO {
  id: string
  name: string
  lifeId: string
  life: LifeDTO
  type: number
  creatorId: string
  creator: UserMinDTO
  privilege: MemorialPrivilegeDTO
  createdAt: number
  updatedAt: number
  isCreatorMember: IsMemberDTO
}
